import { useCallback, useEffect, useState } from "react";

const PHONE_WIDTH = 480;
export const TABLET_WIDTH = 800;
export const WIDE_TABLET_WIDTH = 1024;

export enum deviceTypeEnum {
  PHONE = "phone",
  TABLET = "tablet",
  DESKTOP = "desktop",
}

const getWindowWidth = (): number => {
  const { innerWidth: width } = window;
  return width;
};

const getDeviceType = (width: number): deviceTypeEnum => {
  if (width <= PHONE_WIDTH) {
    return deviceTypeEnum.PHONE;
  }

  if (width <= TABLET_WIDTH) {
    return deviceTypeEnum.TABLET;
  }

  return deviceTypeEnum.DESKTOP;
};

export const useDeviceType = (): deviceTypeEnum => {
  const [deviceType, setDeviceType] = useState<deviceTypeEnum>(getDeviceType(getWindowWidth()));

  const handleResize = useCallback(() => {
    setDeviceType(getDeviceType(getWindowWidth()));
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  return deviceType;
};
